module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./CommitView.js"));
	}, "CommitView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CommitView!./src/pages/Learn/Course/Commit/CommitView.js
// module id = 2205
// module chunks = 367